import { Library } from 'lucide-react';
import Sidebar from '../../../components/ui/SideBar';

export default function LecturerSidebar({ children }) {

  const sidebarLinks = [
    {
      title: 'My Quizes',
      icon: <Library className="w-5 h-5" />,
      href: '/lecturer/quizzes',
    },
  ];

  return (
    <Sidebar sidebarLinks={sidebarLinks} sidebarTitle="Lecturer Panel">
      {children}
    </Sidebar>
  )
}
